import { EMPTY_STRING_ARRAY } from "../constants";
import type { GroupFieldTemplate } from "../types";

export function buildGroupFieldTemplates(
  distinctGroupCombinations: string[],
  aggregationKeys: string[],
  averageKeys: string[],
  priceKey: string,
  volumeKey: string,
): {
  orderedTemplates: GroupFieldTemplate[];
  templatesByGroup: Map<string, GroupFieldTemplate>;
} {
  const groupCount = distinctGroupCombinations.length;
  const aggCount = aggregationKeys.length;
  const avgCount = averageKeys.length;
  const hasAverages = avgCount > 0;

  const orderedTemplates = new Array<GroupFieldTemplate>(groupCount);
  const templatesByGroup = new Map<string, GroupFieldTemplate>();

  for (let index = 0; index < groupCount; index += 1) {
    const groupKey = distinctGroupCombinations[index];
    const prefix = `${groupKey}_`;

    let aggregationFields: string[];
    if (aggCount === 0) {
      aggregationFields = EMPTY_STRING_ARRAY;
    } else {
      aggregationFields = new Array<string>(aggCount);
      for (let aggIndex = 0; aggIndex < aggCount; aggIndex += 1) {
        aggregationFields[aggIndex] = prefix + aggregationKeys[aggIndex];
      }
    }

    let averageFields: string[];
    let averageCountFields: string[];
    let averageSetFields: string[];
    if (!hasAverages) {
      averageFields = EMPTY_STRING_ARRAY;
      averageCountFields = EMPTY_STRING_ARRAY;
      averageSetFields = EMPTY_STRING_ARRAY;
    } else {
      averageFields = new Array<string>(avgCount);
      averageCountFields = new Array<string>(avgCount);
      averageSetFields = new Array<string>(avgCount);
      for (let avgIndex = 0; avgIndex < avgCount; avgIndex += 1) {
        const avgField = prefix + averageKeys[avgIndex];
        averageFields[avgIndex] = avgField;
        averageCountFields[avgIndex] = avgField + "_count";
        averageSetFields[avgIndex] = avgField + "_set";
      }
    }

    const template: GroupFieldTemplate = {
      groupKey,
      volumeField: prefix + volumeKey,
      priceField: prefix + priceKey,
      aggregationFields,
      averageFields,
      averageCountFields,
      averageSetFields,
    };

    orderedTemplates[index] = template;
    templatesByGroup.set(groupKey, template);
  }

  return {
    orderedTemplates,
    templatesByGroup,
  };
}
